import React from 'react';

const ButtonCountComp = ({ index, setButtonCount }) => {

    const handleButtonCount = e => {
        const {value} = e.target;
        if(Number(value) === 0) setButtonCount([]);
        else if(Number(value) === 1) setButtonCount([1]);
        else if(Number(value) === 2) setButtonCount([1,2]);
    }

    return (
        <>
            {/*버튼에 해당하는 내용 */}
            {/*모든 스펙에서 버튼이 2개까지 인것을 확인 ==> radio를 통한 만들고자 하는 사용자가 없음, 1개, 2개를 선택해서 입력 할 수 있도록 구현*/}
            <div className="d-flex align-items-center">
                <div className="form-check pe-3">
                    <input className="form-check-input" type="radio" name={"buttoncount"+index} id={"buttoncount"+index+"_1"}
                           value={0} onChange={handleButtonCount} defaultChecked={true}/>
                    <label className="form-check-label" htmlFor={"buttoncount"+index+"_1"}>
                        없음
                    </label>
                </div>
                <div className="form-check pe-3">
                    <input className="form-check-input" type="radio" name={"buttoncount"+index} id={"buttoncount"+index+"_2"}
                           value={1} onChange={handleButtonCount}/>
                    <label className="form-check-label" htmlFor={"buttoncount"+index+"_2"}>
                        1개
                    </label>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="radio" name={"buttoncount"+index} id={"buttoncount"+index+"_3"}
                           value={2} onChange={handleButtonCount}/>
                    <label className="form-check-label" htmlFor={"buttoncount"+index+"_3"}>
                        2개
                    </label>
                </div>
            </div>
        </>
    );
};

export default ButtonCountComp;
